import { makeAutoObservable } from "mobx";
export class Consents {
    constructor(params) {
        this.subscribeEmail = params.subscribeEmail;
        this.subscribePhone = params.subscribePhone;
        this.subscribeRestaumaticEmail = params.subscribeRestaumaticEmail;
        this.subscribeRestaumaticPhone = params.subscribeRestaumaticPhone;
        makeAutoObservable(this);
    }
    static empty() {
        return new Consents({
            subscribeEmail: false,
            subscribePhone: false,
            subscribeRestaumaticEmail: false,
            subscribeRestaumaticPhone: false,
        });
    }
    static fromStorageData(storageData) {
        if (storageData === null) {
            return Consents.empty();
        }
        return new Consents(storageData);
    }
    get storageData() {
        return {
            subscribeEmail: this.subscribeEmail,
            subscribePhone: this.subscribePhone,
            subscribeRestaumaticEmail: this.subscribeRestaumaticEmail,
            subscribeRestaumaticPhone: this.subscribeRestaumaticPhone,
        };
    }
}
